import { useEffect, useState } from "react";

import { Button, Tooltip, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";

import { ContractorForm, ContractorsDeleteModal } from "components/contractors";
import { useAppDispatch, useAppSelector } from "store";
import { RouteLinks } from "services/router.service";
import editBlue from "data/icons/edit-blue.svg";
import { getContractor } from "store/contractors/contractors.thunks";
import { getContractorsSelector } from "store/contractors/contractors.selector";
import { formatPhoneNumber } from "services/data.service";
import { useBreadcrumbs } from "context/useBreadcrumbs";
import hydraAccountBlue from "data/icons/hydra-account-blue.svg";
import hydraAccount from "data/icons/hydra-account.svg";
import verified from "data/icons/verified.svg";
import api from "services/api.service";

import "./ContractorEdit.scss";

const ContractorEdit = () => {
  const { contractorId } = useParams();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const { currentContractor } = useAppSelector(getContractorsSelector);

  const [ edit, setEdit ] = useState<boolean>(false);
  const [ isDeleteModalOpen, setIsDeleteModalOpen ] = useState<boolean>(false);

  useEffect(() => {
    if (!isNaN(Number(contractorId))) {
      dispatch(getContractor(Number(contractorId)));
    }
  }, []);

  useBreadcrumbs([
    { url: RouteLinks.PROTECTED.CONTRACTS_ROUTES.MAIN, label: "Contractors" },
    { label: "Contractor" },
  ]);

  const handleDeleteContractor = async () => {
    if (!currentContractor) return;

    try {
      await api.deleteContractor(currentContractor);
      message.success("Contractor deleted successfully!");
      setIsDeleteModalOpen(false);
      navigate(RouteLinks.PROTECTED.CONTRACTORS.LIST);
    } catch (e: any) {
      message.error(e.response?.data?.error || e.error || "Something went wrong!");
    }
  };

  return (
    <div className="contractor-form-wrapper">
      {edit ? (
        <ContractorForm contractorId={ contractorId } />
      ) : (
        (
          <div className="contractor-view-wrapper">
            <div className="contractor-info">
              <div className="contractor-info-item">
                <div className="contractor-info-title">
                  {currentContractor?.name}

                  {currentContractor?.has_account ? (
                    <Tooltip title="Has account">
                      <img src={ hydraAccountBlue } alt="" />
                    </Tooltip>
                  ) : (
                    <Tooltip title="No account">
                      <img src={ hydraAccount } alt="" />
                    </Tooltip>
                  )}

                  {currentContractor?.has_verified_account && (
                    <img src={ verified } alt="" />
                  )}
                </div>
              </div>

              <div className="contractor-info-item">
                <div className="contractor-info-item-title">
                  Full name:
                </div>
                <div className="contractor-info-item-value">
                  {currentContractor?.official_name}
                </div>
              </div>

              <div className="contractor-info-item">
                <div className="contractor-info-item-title">
                  Default email:
                </div>
                <div className="contractor-info-item-value">
                  {currentContractor?.default_email}
                </div>
              </div>

              {currentContractor?.phone_number && (
                <div className="contractor-info-item">
                  <div className="contractor-info-item-title">
                    Phone number :
                  </div>
                  <div className="contractor-info-item-value">
                    {formatPhoneNumber(currentContractor?.phone_number || "")}
                  </div>
                </div>
              )}
            </div>

            <Button
              className="edit-button"
              onClick={ () => setEdit(true) }
            >
              Edit
              <img src={ editBlue } alt="" />
            </Button>

            <Button
              className="delete-button"
              danger
              onClick={ () => setIsDeleteModalOpen(true) }
            >
              Delete
            </Button>
          </div>
        )
      )}

      <ContractorsDeleteModal
        deletingContractor={ isDeleteModalOpen ? currentContractor : null }
        onCancel={ () => setIsDeleteModalOpen(false) }
        onConfirm={ handleDeleteContractor }
      />
    </div>
  );
};

export default ContractorEdit;
